module.exports = {"accueil":"Home","mes_demandes":"My requests","mon_compte":"My account","deconnexion":"Logout","application_consommateur":"Consumer application"}


//////////////////
// WEBPACK FOOTER
// ./src/companies/default/lang/en/home/template.lang.json
// module id = XIXS
// module chunks = 1